import { useEffect } from 'react';

import { applyDocumentHead, type DocumentHead } from '@/lib/document-head';

/**
 * 頁面掛載時套用自己的 head。
 *
 * 沒有 cleanup 是刻意的：下一個頁面會覆蓋掉這一份。加 cleanup 反而會在切頁的
 * 空檔閃回預設值。
 *
 * 用 `JSON.stringify` 當相依：呼叫端幾乎都是寫成字面量物件（每次 render 都是
 * 新的參考），依參考比對等於每次 render 都跑一遍。
 */
export function useDocumentHead(head: DocumentHead): void {
  const key = JSON.stringify(head);

  useEffect(() => {
    applyDocumentHead(JSON.parse(key) as DocumentHead);
  }, [key]);
}
